import React from 'react';

import useBuildInfoStore from '@/hooks/useBuildInfo';
import { useGlobalSettingsStore } from '@/shared';

const HeaderDrawerBuildInfo: React.FC<{ onClick?: () => void }> = ({ onClick }) => {
  const { buildInfo } = useBuildInfoStore();
  const { setUiSettings } = useGlobalSettingsStore();

  return (
    <div className="mt-1 mr-4 flex justify-end text-[10px]">
      <div
        className="text-muted-foreground/20 transition-all ease-in-out hover:cursor-pointer hover:font-bold"
        onClick={() => {
          setUiSettings({ isVersionInfoVisible: true });
          onClick?.();
        }}
      >
        v{buildInfo?.version} {buildInfo?.build}
      </div>
    </div>
  );
};

export default HeaderDrawerBuildInfo;
